import React, {useState} from 'react';
import HeaderName from './HeaderName';
import {
  Header,
  HeaderNavigation,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderMenuButton,
} from '@carbon/react';

import UserSwitcher from '../User/UserSwitcher';

//import { sidebarActions } from '../../redux/actions';
import { NavLink } from 'react-router-dom';

import MenuItems from '../Navigation/MenuItems';
import SideNav from '../Navigation/SideNav';
import { UserAvatar } from '@carbon/react/icons';

import AnimatedImposter from './AnimatedImposter';
import { DefaultChildren } from '../User/UserSwitcher/UserSwitcher';
import useUser from '@/lib/hooks/useUser';

const DefaultHeader = () => {

  const {isImposter} = useUser();
  const [isLeftSideNavExpanded, setLeftSideNavExpanded] = useState(false);
  const [isUserMenuExpanded, setUserMenuExpanded] = useState(false);

  const toggleUserMenu = () => setUserMenuExpanded(!isUserMenuExpanded);
  const toggleLeftSideNav = () => setLeftSideNavExpanded(!isLeftSideNavExpanded);
  const hideLeftSideNav = () => setLeftSideNavExpanded(false);

  return (
    <>
      <Header aria-label="Micast-Web">
        <HeaderMenuButton
          aria-label="Open menu"
          onClick={toggleLeftSideNav}
          isActive={isLeftSideNavExpanded}
        />
        <HeaderName
          as={NavLink}
          to="/"
          prefix={
            <img width="75" src="/img/micast_logo_small.png" alt="micast" />
          }>
          web
        </HeaderName>
        <HeaderNavigation aria-label="Micast Web">
          <MenuItems />
        </HeaderNavigation>
        <HeaderGlobalBar>
          {/* <HeaderGlobalAction aria-label="Notifications">
            <Notification20 />
          </HeaderGlobalAction> */}
          <HeaderGlobalAction
            aria-label="Profil Settings"
            isActive={isUserMenuExpanded}
            onClick={toggleUserMenu}>
            {isImposter ? <AnimatedImposter /> : <UserAvatar size="20" />}
          </HeaderGlobalAction>
          {/*<HeaderGlobalAction aria-label="App Switcher" isActive={rightSideNavVisible} onClick={toggleRightSideNav}>
            <AppSwitcher20 />
          </HeaderGlobalAction>*/}
        </HeaderGlobalBar>
        <SideNav leftSideNavVisible={isLeftSideNavExpanded} hide={hideLeftSideNav}>
          <MenuItems />
        </SideNav>
      </Header>
      <UserSwitcher isUserMenuVisible={isUserMenuExpanded}>
        <DefaultChildren isUserMenuVisible={isUserMenuExpanded} hideUserMenu={toggleUserMenu} />
      </UserSwitcher>
    </>
  );
};

export default DefaultHeader;
